import {
    AppConfigurationEdit,
    AppConfigurationList,
} from "@bankingright-dashboard/app-configuration";
import {
    CallToActionCreate,
    CallToActionEdit,
    CallToActionList,
    CallToActionShow,
} from "@bankingright-dashboard/call-to-action";
import { DeviceList, DeviceShow } from "@bankingright-dashboard/devices";
import { Layout } from "@bankingright-dashboard/layout";
import { LocalizationList } from "@bankingright-dashboard/localization";
import { Login } from "@bankingright-dashboard/login";
import {
    LogList,
    LogShow,
    OperationDetails,
} from "@bankingright-dashboard/logs";
import {
    MessageCreate,
    MessageList,
    MessageShow,
} from "@bankingright-dashboard/messages";
import {
    PositionEnrichmentCreate,
    PositionEnrichmentEdit,
    PositionEnrichmentList,
    PositionEnrichmentShow,
} from "@bankingright-dashboard/position-enrichment";
import {
    PushNotificationCreate,
    PushNotificationList,
} from "@bankingright-dashboard/push-notifications";
import {
    SecurityAuditList,
    SecurityAuditShow,
} from "@bankingright-dashboard/security-audits";
import { UserSettings } from "@bankingright-dashboard/settings";
import { ErrorComponent } from "@bankingright-dashboard/ui";
import {
    UserCreate,
    UserEdit,
    UserList,
    UserShow,
} from "@bankingright-dashboard/users";
import { WealthForecastConfigurationOverview } from "@bankingright-dashboard/wealth-forecast-configuration";
import { Authenticated } from "@refinedev/core";
import { NavigateToResource } from "@refinedev/react-router-v6";
import { Outlet, Route, Routes } from "react-router-dom";
import { ReactComponent as Logo } from "./images/pretim_logo.svg";
import { ReactComponent as Logo2 } from "./images/pretim_logo2.svg";
import {
    AccountAccessEdit,
    AccountAccessList,
    AccountAccessShow,
} from "pages/account-access";
import { AccountAccessCreate } from "pages/account-access/create";
import { AccountImport } from "pages/account-import";

export const DoecoeRoutes = () => {
    return (
        <Routes>
            <Route
                element={
                    <Authenticated key="dashboard" fallback={<Outlet />}>
                        <NavigateToResource resource="calltoaction" />
                    </Authenticated>
                }
            >
                <Route
                    path="/login"
                    element={<Login logo={<Logo width="130px" color="black" style={{ marginLeft: "50px", marginRight: "50px" }} />} />}
                />
            </Route>
            <Route
                element={
                    <Authenticated key="dashboard" redirectOnFail="/login">
                        <Layout logo={<Logo2 width="120px" color="black" />}>
                            <Outlet />
                        </Layout>
                    </Authenticated>
                }
            >
                <Route
                    index
                    element={<NavigateToResource resource="calltoaction" />}
                />
                <Route path="calltoaction">
                    <Route index element={<CallToActionList />} />
                    <Route path="create" element={<CallToActionCreate />} />
                    <Route path="edit/:id" element={<CallToActionEdit />} />
                    <Route path="show/:id" element={<CallToActionShow />} />
                </Route>
                <Route path="appconfiguration">
                    <Route index element={<AppConfigurationList />} />
                    <Route path="edit/:id" element={<AppConfigurationEdit />} />
                </Route>
                <Route path="devices">
                    <Route index element={<DeviceList />} />
                    <Route path="show/:id" element={<DeviceShow />} />
                </Route>
                <Route path="messages">
                    <Route index element={<MessageList />} />
                    <Route path="create" element={<MessageCreate />} />
                    <Route path="show/:id" element={<MessageShow />} />
                </Route>
                <Route path="pushnotifications">
                    <Route index element={<PushNotificationList />} />
                    <Route path="create" element={<PushNotificationCreate />} />
                </Route>
                <Route path="users">
                    <Route index element={<UserList />} />
                    <Route path="create" element={<UserCreate />} />
                    <Route path="show/:id" element={<UserShow />} />
                    <Route path="edit/:id" element={<UserEdit />} />
                </Route>
                <Route path="doecoe/accountaccess">
                    <Route index element={<AccountAccessList />} />
                    <Route path="create" element={<AccountAccessCreate />} />
                    <Route path="show/:id" element={<AccountAccessShow />} />
                    <Route path="edit/:id" element={<AccountAccessEdit />} />
                </Route>
                <Route path="logs">
                    <Route index element={<LogList />} />
                    <Route path="show/:id" element={<LogShow />} />
                    <Route
                        path="show/:id/operation"
                        element={<OperationDetails />}
                    />
                </Route>
                <Route path="security/audits">
                    <Route index element={<SecurityAuditList />} />
                    <Route path="show/:id" element={<SecurityAuditShow />} />
                </Route>
                <Route path="localizations">
                    <Route index element={<LocalizationList />} />
                </Route>
                <Route path="positions/enrichments">
                    <Route index element={<PositionEnrichmentList />} />
                    <Route
                        path="create"
                        element={<PositionEnrichmentCreate />}
                    />
                    <Route
                        path="show/:id"
                        element={<PositionEnrichmentShow />}
                    />
                    <Route
                        path="edit/:id"
                        element={<PositionEnrichmentEdit />}
                    />
                </Route>
                <Route path="wealthforecast/configuration">
                    <Route
                        index
                        element={<WealthForecastConfigurationOverview />}
                    />
                </Route>
                <Route path="doecoe/account/import">
                    <Route index element={<AccountImport />} />
                </Route>
                <Route path="settings">
                    <Route index element={<UserSettings />} />
                </Route>
                <Route path="*" element={<ErrorComponent />} />
            </Route>
        </Routes>
    );
};
